import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SharedDirectivesModule } from '@shared/directives/shared-directives.module';
import { EopIconModule } from '@widgets/eop-icon/eop-icon.module';
import { SpinnerModule } from '@widgets/spinner/spinner.module';
import { QuickAccessEntryComponent } from './quick-access-entry/quick-access-entry.component';
import { QuickAccessResultsComponent } from './quick-access-results/quick-access-results.component';

@NgModule({
  declarations: [QuickAccessResultsComponent, QuickAccessEntryComponent],
  imports: [CommonModule, TranslateModule, EopIconModule, SpinnerModule, SharedDirectivesModule],
  exports: [QuickAccessResultsComponent, QuickAccessEntryComponent],
})
export class QuickAccessResultsModule {}
